import { render, staticRenderFns } from "./TextAlign.vue?vue&type=template&id=236af0b6&scoped=true"
import script from "./TextAlign.vue?vue&type=script&lang=js"
export * from "./TextAlign.vue?vue&type=script&lang=js"
import style0 from "./TextAlign.vue?vue&type=style&index=0&id=236af0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236af0b6",
  null
  
)

export default component.exports